export enum BSAStatus {
  NEW = 'new',
  APPROVED = 'approved',
  SUBMITTED = 'submitted',
  WARNINGS = 'acknowledged with warnings',
  ACKNOWLEDGED = 'acknowledged',
  CANCELLED = 'cancelled'
}
